<script lang="ts">
	import type { SvelteAsr } from 'types/common'
	import type { i18n } from 'types/common'

	import { onMount } from 'svelte'
	import { getContext } from 'svelte'

	interface Props {
		asr: SvelteAsr
		chartData: Array<Array<string | number | Date | null>>
	}

	let {
		//
		chartData,
	}: Props = $props()

	const { t: translate } = getContext<i18n>('i18next')

	const options = {
		// todo ig
		title: translate('vehicle.breakEvenGraphTitle', 'Dynamic Line graph: Cost, Cost of Goods Sold, Sales vs. Date'),
		hAxis: {
			title: translate('common:date', 'Date'),
			format: 'MMM dd, yyyy',
		},
		vAxis: {
			title: translate('vehicle.breakEvenGraphVAxisTitle', 'Cost, Cost of Goods Sold, Sales'),
			format: 'currency',
		},
		tooltip: { isHtml: true },
	}

	const data = $derived(google.visualization.arrayToDataTable(chartData))

	onMount(() => {
		const chartDiv = document.getElementById('break-even-graph')
		if (chartDiv) {
			const chart = new google.visualization.LineChart(chartDiv)
			chart.draw(data, options)
		} else {
			alert(translate('vehicle.unableToRenderBreakEvenGraph', 'Unable to render break even graph'))
		}
	})
</script>

<div
	id="break-even-graph"
	style="width: 100%; height: 100%; min-height: 650px;"
></div>
